import {Nullable, AgentsManagementListing} from 'common/types';
import {
  FETCH_AGENTS_MANAGEMENT_LISTING_FAILURE,
  FETCH_AGENTS_MANAGEMENT_LISTING_REQUEST,
  FETCH_AGENTS_MANAGEMENT_LISTING_SUCCESS,
  AgentsAction,
} from '../types';

interface State {
  data: Nullable<AgentsManagementListing>;
  isFetching: boolean;
  error: Nullable<Error>;
}

const initialState: State = {
  data: null,
  isFetching: false,
  error: null,
};

export const managementReducer = (
  state: State = initialState,
  action: AgentsAction
) => {
  switch (action.type) {
    case FETCH_AGENTS_MANAGEMENT_LISTING_REQUEST:
      return {
        ...state,
        isFetching: true,
        error: null,
      };

    case FETCH_AGENTS_MANAGEMENT_LISTING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    case FETCH_AGENTS_MANAGEMENT_LISTING_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
};
